<template>
  <v-container class="pa-5" fluid>
    <v-card>
      <v-card-title>Wholesaler List</v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" lg="4">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              :placeholder="`Search`"
              :hide-details="true"
              solo
              clearable
              @input="onGridSearch"
              v-model="keyword"
              autocomplete="off"
              color="dark"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="12" lg="3">
            <v-checkbox
              label="Show Cancelled Services"
              v-model="showCancelledServices"
              @change="getWholesalersList"
            ></v-checkbox>
          </v-col>

          <v-col
            cols="12"
            sm="2"
            md="2"
            lg="2"
            class="py-0"
            :class="$vuetify.breakpoint.xs ? 'mb-3' : ''"
          >
            <v-card
              class="d-flex justify-end mb-0"
              :class="$vuetify.breakpoint.xs ? 'flex-column mb-0' : 'flex-row'"
              flat
            >
              <v-card flat>
                <v-btn
                  color="dark"
                  dark
                  class="mt-4"
                  @click="showAdd"
                  :class="$vuetify.breakpoint.xs ? 'ml-0' : 'ml-4'"
                  :width="$vuetify.breakpoint.xs ? '100%' : ''"
                >Create Wholesaler</v-btn
                >
              </v-card>
            </v-card>
          </v-col>

          <v-spacer></v-spacer>
          <v-col cols="6" sm="2" lg="2">
            <v-select
              :items="listSize"
              label="No. of Rows"
              v-model="pageSize"
              @change="onGridSearch"
              class="page-size"
              color="dark"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <ag-grid-vue
              class="ag-theme-alpine"
              style="width: 100%; height: 60vh"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="rowData"
              :gridOptions="gridOptions"
              rowSelection="single"
              @grid-ready="onGridReady"
              @row-selected="onRowSelected"
            ></ag-grid-vue>
          </v-col>
        </v-row>
        <v-dialog v-model="wholesalerEditable" width="50vw">
          <edit-wholesaler
            v-if="wholesalerEditable"
            :wholesalerForEdit="wholesalerForEdit"
            :wholesalerEditable="wholesalerEditable"
            @close="close"
            @save="save"
          ></edit-wholesaler>
        </v-dialog>
        <v-dialog v-model="wholesalerAdding" width="50vw">
          <add-wholesaler
            @close="closeAdd"
            @save="saveAdd"
          ></add-wholesaler>
        </v-dialog>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "WholesalerList",
  data: () => ({
    showCancelledServices: false,
    frameworkComponents: null,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    gridOptions: {},
    components: null,
    wholesalerEditable: false,
    wholesalerAdding: false,
    wholesalerForEdit: null,
    rowData: [],
    keyword: "",
    pageSize: 50,
    listSize: [
      {
        text: "10",
        value: 10
      },
      {
        text: "30",
        value: 30
      },
      {
        text: "50",
        value: 50
      },
      {
        text: "100",
        value: 100
      },
      {
        text: "Show All",
        value: -1
      }
    ],
    wholesalerToUpdate: [],
    columnDefs: [
      {
        headerName: "Account Number",
        field: "accountNumber",
        minWidth: 150,
        pinned: "left"
      },
      {
        headerName: "Name",
        field: "name",
        pinned: "left",
        minWidth: 250
      },
      {
        headerName: "Company",
        field: "company",
        pinned: "left",
        minWidth: 250
      },
      {
        headerName: "Cancel Date",
        field: "cancelDate",
        minWidth: 150,
        sortingOrder: ["asc", "desc", null]
      },
      {
        headerName: "Contact Email",
        field: "contactEmail",
        minWidth: 250
      },
      {
        headerName: "OneLogin Email",
        field: "oneLoginEmail",
        minWidth: 250
      },
      {
        headerName: "Default Billing ID",
        field: "defaultBillingId",
        minWidth: 150
      },
      {
        headerName: "SP Code",
        field: "sp_code",
        minWidth: 100
      },
      {
        headerName: "Active",
        field: "isActive",
        minWidth: 100,
        cellRenderer: function(params) {
          if (params.value) {
            return "True";
          }
          return "False";
        }
      },
      {
        headerName: "Radius User",
        field: "is_radius_user",
        minWidth: 150,
        cellRenderer: function(params) {
          if (params.value) {
            return params.value.toUpperCase();
          }
          return params.value;
        }
      },
      {
        headerName: "Visp User",
        field: "vispUser",
        minWidth: 150,
        cellRenderer: function(params) {
          if (params.value) {
            return "True";
          }
          return "False";
        }
      },
      {
        headerName: "Contract Term",
        field: "useContractTerm",
        minWidth: 150,
        cellRenderer: function(params) {
          if (params.value) {
            return "Yes";
          }
          return "No";
        }
      }
    ],
    wholesalerFeatures: []
  }),
  components: { AgGridVue },
  beforeMount() {
    let vm = this;
    vm.getWholesalersList();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    getWholesalerFeatures(event) {
      let vm = this;
      vm.$store
        .dispatch(
          "service/getWholesalerFeatureByWholesalerId",
          event.data.accountNumber
        )
        .then(data => {
          if (data) {
            event.data.features = [];
            data.forEach(e => {
              if (e.featureValue) event.data.features.push(e.featureId);
            });

            vm.wholesalerFeatures = data;
          }
          vm.wholesalerEditable = true;
          vm.wholesalerForEdit = event.data;
          event.node.setSelected(false, true);
        })
        .catch(e => {
          console.log(e);
        });
    },
    onGridReady() {
      let vm = this;
      vm.gridApi.sizeColumnsToFit();
      vm.hasUpdates = vm.hasWholesalerToUpdate;
    },
    onRowSelected(event) {
      let vm = this;
      vm.getWholesalerFeatures(event);
    },
    getWholesalersList() {
      let vm = this;

      vm.getActiveWholesalers({
        keyword: vm.keyword,
        pageSize: vm.pageSize,
        showCancelled: vm.showCancelledServices
      })
        .then(() => {
          vm.rowData = vm.activeWholesalers;
          vm.gridOptions.api.sizeColumnsToFit();
        })
        .catch(() => {});
    },
    save(features) {
      let vm = this;
      let wholesaler = vm.wholesalersToUpdate[0];
      wholesaler.features = vm.getActiveFeatures(wholesaler, features);

      vm.updateWholesalerDetails(wholesaler).then(() => {
        vm.getWholesalersList();
        vm.wholesalerEditable = false;
      });
    },
    getActiveFeatures(wholesaler, features) {
      let vm = this;
      let featuresList = [];
      if (!wholesaler.features) return;
      wholesaler.features.forEach(x => {
        let feature = vm.wholesalerFeatures.filter(y => y.featureId == x)[0];
        if (feature) {
          feature.featureValue = true;
          featuresList.push(feature);
        } else {
          featuresList.push({
            id: 0,
            wholesalerId: wholesaler.accountNumber,
            featureId: x,
            featureValue: true,
            featureDescription: features.filter(y => y.id == x)[0].description
          });
        }
      });

      let unTicked = vm.wholesalerFeatures.filter(
        ({ featureId: id1 }) =>
          !featuresList.some(({ featureId: id2 }) => id2 === id1)
      );

      unTicked.map(x => {
        x.featureValue = false;
        return x;
      });

      featuresList.push(...unTicked);

      return featuresList;
    },
    close() {
      let vm = this;
      vm.wholesalerEditable = false;
    },
    showAdd() {
      let vm = this;
      vm.wholesalerAdding = true;
    },
    closeAdd() {
      let vm = this;
      vm.wholesalerAdding = false;
    },
    saveAdd() {
      let vm = this;
      vm.wholesalerAdding = false;
      vm.getWholesalersList();
    },
    onGridSearch() {
      let vm = this;

      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        vm.getWholesalersList();
      });
    }
  }
};
</script>
<style scoped>
.for-deletion {
  background-color: lightcoral !important;
}
</style>
